import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Confetti from 'react-confetti';
import { useNavigate } from 'react-router-dom';
import badgeImage from '../assets/img/badges/1_badge_rabbit.png';
import icon_hspu from '../assets/img/icon_hspu.svg';
import { FaTrophy } from 'react-icons/fa';

function ModalCongrats({ show, onHide }) {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const navigate = useNavigate();
  const DEFAULT_AVATAR_URL =
    "https://t4astorage580ed-dev.s3.us-east-2.amazonaws.com/public/avatars/avatar_alien_white.jpeg";

  useEffect(() => {
    if (show) {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }
  }, [show]);

  return (
    <>
      {show && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={250}
          style={{
            zIndex: 100005,
            position: 'fixed',
            top: 0,
            left: 0,
          }}
        />
      )}

      <Modal
        show={show}
        onHide={onHide}
        centered
        backdrop="static"
        keyboard={false}
        className="modal-congrats"
      >
        <Modal.Header closeButton closeVariant="white" style={{ borderBottom: 'none' }}>
          <Modal.Title style={{ fontWeight: '700', color: '#fff' }}>
            🎉 Congratulations!
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ textAlign: 'center', paddingTop: '10px' }}>
          <p>
            You just unlocked <strong>Level 1</strong> and earned your first badge!
          </p>
          <img
            src={badgeImage}
            alt="Badge"
            style={{
              maxWidth: '120px',
              display: 'block',
              margin: '15px auto 25px',
            }}
          />

          <h5 style={{ marginBottom: '15px', fontWeight: 600 }}>What to do next</h5>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              alignItems: 'center',
            }}
          >
            {/* Update Avatar */}
            <Button
              variant="dark"
              onClick={() => {
                onHide();
                navigate('/settings');
              }}
              style={{
                width: '80%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                color: '#fff',
              }}
            >
              <img
                src={DEFAULT_AVATAR_URL}
                alt="Default avatar"
                style={{ width: 18, height: 18, borderRadius: '50%' }}
              />
              Update your avatar
            </Button>

            {/* Program */}
            <Button
              variant="secondary"
              onClick={() => {
                onHide();
                navigate('/program');
              }}
              style={{
                width: '80%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                backgroundColor: '#555',
                border: 'none',
                color: '#fff',
              }}
            >
              <img
                src={icon_hspu}
                alt="Program Icon"
                style={{ width: 18, height: 18, filter: 'invert(1)' }}
              />
              Check out the program
            </Button>

            {/* Progress */}
            <Button
              onClick={() => {
                onHide();
                navigate('/progress');
              }}
              style={{
                width: '80%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                backgroundColor: '#daa520', // gold
                borderColor: '#daa520',
                color: '#000',
                fontWeight: '600',
              }}
            >
              <FaTrophy />
              Start logging progress
            </Button>
          </div>
        </Modal.Body>

        <Modal.Footer style={{ borderTop: 'none' }}>
          <Button
            variant="outline-secondary"
            onClick={onHide}
            style={{ width: '100%' }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCongrats;
